import { render, staticRenderFns } from "./ManuallyRows.vue?vue&type=template&id=06b29718&scoped=true&"
import script from "./ManuallyRows.vue?vue&type=script&lang=js&"
export * from "./ManuallyRows.vue?vue&type=script&lang=js&"
import style0 from "./ManuallyRows.vue?vue&type=style&index=0&id=06b29718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b29718",
  null
  
)

export default component.exports